import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    ContactTempService,
    ContactTempPopupService,
    ContactTempComponent,
    ContactTempDetailComponent,
    ContactTempDialogComponent,
    ContactTempPopupComponent,
    ContactTempDeletePopupComponent,
    ContactTempDeleteDialogComponent,
    contactTempRoute,
    contactTempPopupRoute,
    ContactTempResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...contactTempRoute,
    ...contactTempPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ContactTempComponent,
        ContactTempDetailComponent,
        ContactTempDialogComponent,
        ContactTempDeleteDialogComponent,
        ContactTempPopupComponent,
        ContactTempDeletePopupComponent,
    ],
    entryComponents: [
        ContactTempComponent,
        ContactTempDialogComponent,
        ContactTempPopupComponent,
        ContactTempDeleteDialogComponent,
        ContactTempDeletePopupComponent,
    ],
    providers: [
        ContactTempService,
        ContactTempPopupService,
        ContactTempResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerContactTempModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact-temp/contact-temp.module.ts